var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1431",
    "data-name": "Tracciato 1431",
    d: "M21.15,2.15a19,19,0,1,0,19,19A19,19,0,0,0,21.15,2.15Zm-15.721,19A15.721,15.721,0,1,1,21.15,36.871,15.721,15.721,0,0,1,5.429,21.15Zm15.507-9.355a9.25,9.25,0,0,0-9.141,9.355,9.25,9.25,0,0,0,9.141,9.355,8.973,8.973,0,0,0,5.5-1.885,9.3,9.3,0,0,0,1.822-1.873,1.64,1.64,0,0,0-2.648-1.934,6.012,6.012,0,0,1-1.179,1.213,5.7,5.7,0,0,1-3.5,1.2,6.08,6.08,0,0,1,0-12.152,5.694,5.694,0,0,1,3.5,1.2,6.013,6.013,0,0,1,1.179,1.213,1.64,1.64,0,0,0,2.648-1.934,9.3,9.3,0,0,0-1.822-1.873A8.973,8.973,0,0,0,20.936,11.795Z",
    transform: "translate(-2.15 -2.15)",
    fill: "#14bf95",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.c20c2c79ff31ba9e9f151d80546fdc0d.svg";
export { ForwardRef as ReactComponent };